// import { lazy } from "react";

// /**
//  * Safely loads a lazy React component.
//  *
//  * When a deployment replaces old JavaScript chunks, users with an
//  * already-open browser tab can receive a ChunkLoadError. This helper
//  * reloads the application once and retries the import.
//  */
// const safeLazy = (importFunction, componentName = "Component") => {
//   return lazy(async () => {
//     const reloadStorageKey = `nexgen-lazy-reload-${componentName}`;

//     try {
//       const componentModule = await importFunction();

//       sessionStorage.removeItem(reloadStorageKey);

//       return componentModule;
//     } catch (error) {
//       const errorMessage =
//         error instanceof Error ? error.message : String(error);

//       const isChunkLoadError =
//         error?.name === "ChunkLoadError" ||
//         /loading chunk/i.test(errorMessage) ||
//         /failed to fetch dynamically imported module/i.test(errorMessage) ||
//         /importing a module script failed/i.test(errorMessage);

//       const hasAlreadyReloaded =
//         sessionStorage.getItem(reloadStorageKey) === "true";

//       console.error(`[safeLazy] Failed to load ${componentName}:`, error);

//       if (isChunkLoadError && !hasAlreadyReloaded) {
//         sessionStorage.setItem(reloadStorageKey, "true");

//         window.location.reload();

//         return new Promise(() => {});
//       }

//       sessionStorage.removeItem(reloadStorageKey);

//       throw error;
//     }
//   });
// };

// export default safeLazy;

import { lazy } from "react";

const isChunkLoadError = (error) => {
  const message = error?.message || String(error || "");

  return (
    error?.name === "ChunkLoadError" ||
    /loading chunk/i.test(message) ||
    /failed to fetch dynamically imported module/i.test(message) ||
    /importing a module script failed/i.test(message)
  );
};

const lazyWithRetry = (importFunction, componentName) => {
  return lazy(async () => {
    const storageKey = `nexgen-chunk-reload-${componentName}`;

    try {
      const componentModule = await importFunction();

      sessionStorage.removeItem(storageKey);

      return componentModule;
    } catch (error) {
      console.error(`[Lazy Load Error] ${componentName}:`, error);

      const alreadyReloaded = sessionStorage.getItem(storageKey) === "true";

      if (isChunkLoadError(error) && !alreadyReloaded) {
        sessionStorage.setItem(storageKey, "true");

        window.location.reload();

        return new Promise(() => {});
      }

      sessionStorage.removeItem(storageKey);

      throw error;
    }
  });
};

export default lazyWithRetry;
